import {INote} from './note.model';
import {IUser} from '../../core/user/user.model';
import {IOrganization} from "./organization.model";

export interface IEmployee {
  id?: number;
  itemName?: string;
  status?: string;
  login?: string;
  firstName?: string;
  color?: any;
  lastName?: string;
  image?: any;
  phone?: string;
  email?: string;
  createdDate?: any;
  lastModifiedBy?: string;
  lastModifiedDate?: any;
  dateOfBirth?: any;
  isdeleted?: boolean;
  issuperadmin?: boolean;
  user?: IUser;
  organization?: IOrganization;

  //notes?: INote[];
}

export class Employee implements IEmployee {
  constructor(public id?: number,
              public itemName?: string,
              public status?: string,
              public login?: string,
              public firstName?: string,
              public lastName?: string,
              public phone?: string,
              public image?: string,
              public email?: string,
              public isdeleted?: boolean,
              public issuperadmin?: boolean,
              public dateOfBirth?: any,
              public createdDate?: any,
              public lastModifiedBy?: string,
              public lastModifiedDate?: any,
              public user?: IUser
    ,
              public organization?: IOrganization) {

    this.id = id ? id : null;
    this.login = login ? login : null;
    this.firstName = firstName ? firstName : null;
    this.itemName = itemName ? itemName : null;
    this.status = status ? status : null;
    this.lastName = lastName ? lastName : null;
    this.email = email ? email : null;
    this.dateOfBirth = dateOfBirth ? dateOfBirth : null;
    this.createdDate = createdDate ? createdDate : null;
    this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
    this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
    this.user = user ? user : null;
    this.organization = organization ? organization : null;
    this.isdeleted = false;
    this.issuperadmin = false;



  }
}
